import React, { useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import editIcons from "../../../../../assets/icons/editIcons.svg";

import addREC from "../../../../../assets/icons/addREC.svg";
import CompanyDashboardInitiativeDrawerSideBarDepartmentPopup from "./company-dashboard-initiative-drawer-side-bar-department-popup";
import "./company-dashboard-initiative-drawer-side-bar.scss";

const CompanyDashboardInitiativeDrawerSideBarDepartment: any = (props: any) => {// NOSONAR
  const {
    selectedAddedDepartment,
    setSelectedAddedDepartment,
    initiativeIdTooltip,
    initiativeId,
    mainDepartmentList,
    handleCreateInitiative,
    payloadData,
    canEdit,
    canWrite,
    handleDepartmentRemoval,
    initiativeDataPermissions,
    selectedDepartment,
    setSelectedDepartment,
    selectedRole,
    setSelectedRole,
    selectedAddedRole,
    setSelectedAddedRole,
    employeesList,
    fetchInitiativeById,
  } = props;
  const [isShowEditDepartment, setIsShowEditDepartment] = useState(false);
  const [departments, setDepartments] = useState(mainDepartmentList);
  const handleSortDepartment = () => {
    // Always use the original mainDepartmentList for sorting, not the filtered departments
    if (!mainDepartmentList || !Array.isArray(mainDepartmentList)) return;

    // Get selected department texts for easier comparison
    const selectedTexts =
      selectedDepartment?.map((dept: any) => dept?.text) || [];

    // Filter and sort selected departments
    const selectDep = mainDepartmentList
      .filter((department: any) => selectedTexts.includes(department?.text))
      .sort((a: any, b: any) => a?.text.localeCompare(b?.text));

    // Filter and sort unselected departments
    const unselectDep = mainDepartmentList
      .filter((department: any) => !selectedTexts.includes(department?.text))
      .sort((a: any, b: any) => a?.text.localeCompare(b?.text));

    // Set the sorted departments with selected first, then unselected
    setDepartments([...selectDep, ...unselectDep]);
  };

  useEffect(() => {
    setDepartments(mainDepartmentList);
  }, [mainDepartmentList]);

  useEffect(() => {
    setSelectedDepartment(selectedAddedDepartment || []);
  }, [selectedAddedDepartment]);

  // Sort departments whenever selectedDepartment or mainDepartmentList changes
  useEffect(() => {
    if (mainDepartmentList?.length > 0) {
      handleSortDepartment();
    }
  }, [selectedDepartment, mainDepartmentList]);

  const handleRemoveDepartment = (
    departmentText: any,
    departmentId?: any,
    departmentEmployeeId?: any,
  ) => {
    let filteredDepartments;

    // Use ID for more precise removal if available
    if (departmentId === undefined) {
      filteredDepartments = selectedDepartment.filter(
        (dept: any) => dept.text !== departmentText,
      );
    } else {
      filteredDepartments = selectedDepartment.filter(
        (dept: any) => dept.id !== departmentId,
      );
    }
    // );
    // );

    // Update both local state AND parent state immediately
    setSelectedDepartment(filteredDepartments);
  };

  const handleAddDepartment = (
    departmentText: any,
    departmentId: any,
    departmentEmployeeId: any,
  ) => {
    // Check if department is already selected by comparing both text and id
    const isAlreadySelected = selectedDepartment.some(
      (dept: any) => dept.text === departmentText || dept.id === departmentId,
    );
    const employeesSelectInfo = employeesList?.find(
      (emp: any) => emp?.employeeId === departmentEmployeeId,
    );
    const employeeData = employeesSelectInfo
      ? {
          id: employeesSelectInfo?.employeeId,
          name: employeesSelectInfo?.employeeFullName,
          label: employeesSelectInfo?.employeeFullName,
          profileImage: employeesSelectInfo?.employeeImage,
          role: "Owner",
          roleId: employeesSelectInfo?.roles?.[0]?.roleId || null,
          departmentId: employeesSelectInfo?.departmentId || null,
          departmentName: employeesSelectInfo?.departmentName || null,
        }
      : null;
    if (
      !selectedRole?.find(
        (employeeDataInfo: any) =>
          employeeDataInfo?.id === departmentEmployeeId,
      ) &&
      employeeData
    ) {
      setSelectedRole((prevSelected: any) => [...prevSelected, employeeData]);
    }

    if (
      !selectedAddedRole?.find(
        (employeeDataInfo: any) =>
          employeeDataInfo?.id === departmentEmployeeId,
      ) &&
      employeeData
    ) {
      setSelectedAddedRole((prevSelected: any) => [
        ...prevSelected,
        employeeData,
      ]);
    }

    if (!isAlreadySelected) {
      const newSelected = [
        ...selectedDepartment,
        {
          text: departmentText,
          id: departmentId,
          employeeId: departmentEmployeeId,
        },
      ];

      setSelectedDepartment(newSelected);
    }
  };

  const onSearch = (value: string) => {
    if (value) {
      const filteredDepartments = departments.filter((department: any) =>
        department.text.toLowerCase().includes(value.toLowerCase()),
      );
      setDepartments(filteredDepartments);
    } else {
      setDepartments(mainDepartmentList);
    }
  };

  let actionIcon: React.ReactNode = null;
  if (initiativeId && selectedAddedDepartment.length > 0) {
    if (canEdit && initiativeDataPermissions) {
      actionIcon = <img src={editIcons} alt="edit" />;
    } else if (canWrite && initiativeDataPermissions) {
      actionIcon = <img src={addREC} alt="add" />;
    }
  } else if (canWrite && initiativeDataPermissions) {
    actionIcon = <img src={addREC} alt="add" />;
  } else if (canEdit && initiativeDataPermissions) {
    actionIcon = <img src={editIcons} alt="edit" />;
  }

  return (
    <>
      <div className="company-dashboard-initiative-drawer-side-bar-content-header">
        <div>Participating Department(s)</div>
        <Tooltip title={initiativeIdTooltip}>
          <button
            className="company-dashboard-initiative-drawer-side-bar-content-header-edit-icon"
            onClick={() => {
              if (initiativeId && canEdit) {
                setSelectedDepartment(selectedAddedDepartment || []);
                setIsShowEditDepartment(true);
              }
            }}
            style={{
              cursor:
                !initiativeId || (!canEdit && !canWrite)
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            {actionIcon}
          </button>
        </Tooltip>
      </div>
      <div className="company-dashboard-initiative-drawer-side-bar-content-participating">
        {selectedAddedDepartment.length === 0 ? (
          <div className="company-dashboard-initiative-drawer-side-bar-content-participating-no-department">
            <div className="company-dashboard-initiative-drawer-side-bar-content-participating-no-department-text ">
              You don't have any department(s)
            </div>
            {canWrite && initiativeDataPermissions && (
              <Tooltip title={initiativeIdTooltip}>
                <button
                  className="company-dashboard-initiative-drawer-side-bar-content-participating-no-department-button"
                  onClick={() =>
                    initiativeId ? setIsShowEditDepartment(true) : null
                  }
                  style={{ cursor: initiativeId ? "pointer" : "not-allowed" }}
                >
                  Add Departments
                </button>
              </Tooltip>
            )}
          </div>
        ) : (
          <div className="company-dashboard-initiative-drawer-side-bar-content-participating-content">
            {selectedAddedDepartment.map((department: any, index: number) => (
              <div
                className="company-dashboard-initiative-drawer-side-bar-content-participating-content-item"
                key={index + 1}
                style={{
                  backgroundColor: department?.color || "#E8F0FE",
                }}
              >
                <div className="company-dashboard-initiative-drawer-side-bar-content-participating-content-item-label">
                  {department?.text}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <CompanyDashboardInitiativeDrawerSideBarDepartmentPopup
        isShowEditDepartment={isShowEditDepartment}
        onSearch={onSearch}
        departments={departments}
        selectedDepartment={selectedDepartment}
        handleRemoveDepartment={handleRemoveDepartment}
        handleAddDepartment={handleAddDepartment}
        setIsShowEditDepartment={setIsShowEditDepartment}
        setSelectedAddedDepartment={setSelectedAddedDepartment}
        handleCreateInitiative={handleCreateInitiative}
        payloadData={payloadData}
        handleDepartmentRemoval={handleDepartmentRemoval}
        fetchInitiativeById={fetchInitiativeById}
        initiativeId={initiativeId}
      />
    </>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarDepartment;
